import React from 'react';
import TooltipComponent from '../../common/TooltipComponent';
import DocAvatarUi from './DoctorAvatarUi';

const DoctorFilterStripUi = ({
    doctorName,
    doctorPic,
    aptCount,
    isSelected = false,
    showAptCount = true,
    onClick,
}: {
    doctorName?: string;
    doctorPic?: string;
    isSelected?: boolean;
    showAptCount?: boolean;
    aptCount?: number;
    onClick: () => void;
}): JSX.Element => {
    // const commonStatusStyles = "dr-w-8 dr-h-8 dr-rounded-full";
    // const statusMapping = useMemo(
    //   () =>
    //     doctorStatusList.map((status) => {
    //       if (status === CHECKED_IN_STATUS.ON_GOING) {
    //         return (
    //           <div
    //             className={`${commonStatusStyles} dr-bg-darwin-green-primary`}
    //           />
    //         );
    //       } else if (status === CHECKED_IN_STATUS.UP_NEXT) {
    //         return (
    //           <div
    //             className={`${commonStatusStyles} dr-bg-darwin-yellow-primary`}
    //           />
    //         );
    //       }
    //       return (
    //         <div className={`${commonStatusStyles} dr-bg-darwin-neutral-200`} />
    //       );
    //     }),
    //   [doctorStatusList]
    // );

    return (
        <TooltipComponent title={doctorName || 'All doctors'} placement="top">
            <div
                id={`doctor-chip-${doctorName}`}
                onClick={onClick}
                className={`border-1 ${
                    isSelected ? 'dr-border-darwin-primary-primary' : 'dr-border-darwin-neutral-200'
                } dr-py-6 dr-px-8 dr-items-center dr-bg-darwin-neutral-0 dr-rounded-8 dr-flex dr-flex-row dr-max-w-full dr-justify-between dr-cursor-pointer dr-min-w-160 dr-space-x-4 ${
                    doctorName ? '' : 'dr-sticky dr-left-0'
                }`}
            >
                <DocAvatarUi name={doctorName} pic={doctorPic} isSelected={isSelected} />
                <div
                    className={`${
                        isSelected
                            ? 'dr-text-darwin-primary-primary BodyBold'
                            : 'dr-text-darwin-neutral-1000 BodyRegular'
                    } dr-ml-8 dr-mr-4 dr-flex-1 dr-flex dr-flex-row dr-items-center`}
                >
                    <div className="dr-line-clamp-1">{doctorName || 'All doctors'}</div>
                    {/* TODO: Pick color mapping */}
                    {/* <div className="dr-flex dr-justify-center dr-items-center dr-space-x-4 dr-ml-8">
          {...statusMapping}
        </div> */}
                </div>
                {showAptCount ? (
                    <div className="dr-flex dr-items-center dr-justify-center dr-rounded-40 dr-bg-darwin-primary-bg-light dr-text-darwin-primary-primary dr-w-24 dr-h-24">
                        {aptCount}
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </TooltipComponent>
    );
};

export default DoctorFilterStripUi;
